import { ConfigService } from '@shared/services/config.service';
import { cn } from '@utils/utils';

export const Footer = () => {
  const envBadge = ConfigService.getEnvironmentBadge();
  const isTest = !!envBadge;

  return (
    <footer
      className={cn(
        'backdrop-blur-md border rounded-2xl shadow-lg px-6 py-1',
        envBadge?.variant === 'staging' && 'bg-blue-600/70 border-blue-400/50',
        envBadge?.variant === 'local' && 'bg-amber-600/70 border-amber-500/50',
        !isTest && 'bg-white/60 border-white/20'
      )}
    >
      <div className="flex flex-col items-center text-center">
        <div className={cn('text-sm', isTest ? 'text-white' : 'text-gray-700')}>
          © {new Date().getFullYear()} Erlia Earth Data Lab.
        </div>
        <div className={cn('text-sm', isTest ? 'text-white' : 'text-gray-700')}>
          Versión {ConfigService.getAppVersion()}
          {envBadge ? ` (${envBadge.shortLabel})` : ''}
        </div>
      </div>
    </footer>
  );
}; 